<shared-second-nav [links]="tabLinks" class="tab-nav dropdown">
</shared-second-nav>
